export default "__VITE_ASSET__bb8ecd59__"